import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useMember} from 'src/feature/members/hook'
import {useLocation} from 'react-router-dom'
import FilterDrawerTrx from '../List/FilterDrawerTrx'
import {useState} from 'react'

const MemberDetailTransactions = ({
  loading,
}: {
  loading: boolean
  search: string
  setSearch: any
}) => {
  const intl = useIntl()

  let location = useLocation()

  const {detailTab, listFilterTrx, listFilterSetTrx} = useMember()
  const [open, setOpen] = useState(false)

  const data = detailTab?.Transaction?.dataList
  const paging = detailTab?.Transaction?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'OrderId',
      dataIndex: 'orderId',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.ORDER_ID'}),
    },
    /* {
      key: 'transactionId',
      dataIndex: 'transactionId',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.TRANSACTION_ID'}),
    }, */
    {
      key: 'Date',
      dataIndex: 'date',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.DATE_TIME'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    /* {
      key: 'StoreId',
      dataIndex: 'storeNo',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.STORE_ID'}),
    }, */
    {
      key: 'TerminalId',
      dataIndex: 'posNo',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.TERMINAL_ID'}),
      render: (text: string | null) => {
        return <>{!text ? '-' : text}</>
      },
    },
    {
      key: 'Type',
      dataIndex: 'type',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.TYPE'}),
      render: (text: string) => {
        let color = 'text-success'

        switch (text) {
          case 'Cancel':
            color = 'text-error'
            break
          case 'Refund':
            color = 'text-refund'
            break
          case 'Sale':
            color = 'text-success'
            break
          case 'SignUp':
            color = 'text-signup'
            break
          case 'Birthday':
            color = 'text-info'
            break
          default:
            color = 'text-success'
            break
        }

        return <span className={color}>{text ? text : '-'}</span>
      },
    },
    {
      key: 'Amount',
      dataIndex: 'paidAmount',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.AMOUNT'}),
      customMonetize: true,
      // render: (text: string) => <>{text}</>,
    },
    /*  {
      key: 'Channel',
      dataIndex: 'channel',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.CHANNEL'}),
    }, */
    {
      key: 'detailURL',
      dataIndex: 'transactionId',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.ACTION'}),
      render: (transactionId: string) => (
        <a href={`/transaction/${transactionId}?members=${location?.pathname?.split('/')?.pop()}`}>
          {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.DETAIL'})}
        </a>
      ),
    },
  ]

  const getuserIDParam = () => {
    const path = window.location.pathname
    const pathParts = path.split('/')
    const userID = pathParts[pathParts.length - 1]
    return userID
  }

  return (
    <>
      <FilterDrawerTrx memberId={getuserIDParam()} setOpen={setOpen} open={open} />
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS'})}
              </h3>
              <p className=' fw-normal fs-6'>
                {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS_TOOLTIP'})}
              </p>
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  className='btn btn-light'
                  onClick={() => setOpen(true)}
                  // id='kt_filter_membertrx_button'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              dataSource={data}
              tableName={'memberTrx'}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!detailTab || !detailTab.Transaction) return
                  const {pageSize, current} = page
                  const currentPage =
                    pageSize !== detailTab.Transaction.paging.pageSize ? 1 : current

                  listFilterSetTrx({
                    ...listFilterTrx,
                    paging: {
                      ...listFilterTrx.paging,
                      pageSize,
                      currentPageNumber: currentPage,
                    },
                  })

                  /* detailTabSet({
                    ...detailTab,
                    Transaction: {
                      ...detailTab.Transaction,
                      paging: {
                        ...paging,
                        currentPageNumber: currentPage,
                        pageSize: pageSize,
                      },
                    },
                  }) */
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default MemberDetailTransactions
